(function () {
  'use strict';

  // Single capture-phase click guard. Fires before UpCart, UploadKit, the theme
  // form handler, and any other click listener. Re-checks live on every click,
  // so it survives variant swaps / DOM re-renders. Does NOT touch the button's
  // disabled state or text — the existing "Make a Selection" variant logic is
  // left completely alone.

  function photoRequiredButMissing() {
    var uk = document.querySelector('.uploadkit-button[data-uploader-id]');
    if (!uk) return false;                                       // no upload field on this product
    return !uk.classList.contains('uploadkit-button-uploaded');  // field exists, nothing uploaded
  }

  function flagUploadField() {
    var uk = document.querySelector('.uploadkit-button[data-uploader-id]');
    if (!uk) return;

    // Inline message directly under the upload button (created once)
    var msg = document.getElementById('uk-required-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'uk-required-msg';
      msg.textContent = 'Please upload a photo';
      msg.style.cssText = 'color:#c00;font-weight:600;margin-top:8px;';
      uk.insertAdjacentElement('afterend', msg);
    }
    msg.style.display = 'block';

    uk.style.outline = '3px solid #c00';
    uk.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearFlag() {
    var uk = document.querySelector('.uploadkit-button[data-uploader-id]');
    if (uk) uk.style.outline = '';
    var msg = document.getElementById('uk-required-msg');
    if (msg) msg.style.display = 'none';
  }

  // Enforcement: block any Add to Cart click when a photo is required but absent.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit');
    if (!btn) return;
    if (photoRequiredButMissing()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flagUploadField();
    }
  }, true); // capture phase — runs before every other handler

  // Clear the warning the moment a photo is uploaded.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.uploadkit-button')) {
      // give UploadKit a tick to apply its uploaded class, then re-check
      setTimeout(clearFlag, 500);
    }
  });

})();
